import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './MobileMenu.css';
import { FaTimes } from 'react-icons/fa';

const MobileMenu = ({ isOpen, onClose }) => {
    const [apiExpanded, setApiExpanded] = useState(false);
    const [sitesExpanded, setSitesExpanded] = useState(false);

    if (!isOpen) return null;

    const toggleApiDropdown = () => {
        setApiExpanded(!apiExpanded);
        setSitesExpanded(false);
    };

    const toggleSitesDropdown = () => {
        setSitesExpanded(!sitesExpanded);
        setApiExpanded(false);
    };

    return (
        <div className="mobile-menu-overlay">
            <div className="mobile-menu-container">
                <div className="mobile-menu-header">
                    <button className="close-button" onClick={onClose}>
                        <FaTimes size={24} />
                    </button>
                </div>

                <div className="mobile-menu-content">
                    <a href="mailto:contact@datagreffe.ci" className="mobile-menu-item">
                        contact@datagreffe.ci
                    </a>

                    {/* <div className="mobile-menu-item">
                        <button className="dropdown-trigger" onClick={toggleApiDropdown}>
                            API <span className="dropdown-arrow">{apiExpanded ? '▲' : '▼'}</span>
                        </button>

                        {apiExpanded && (
                            <div className="mobile-submenu">
                                <Link to="/api-docs" className="submenu-item">
                                    <div className="submenu-title">Documentation</div>
                                    <div className="submenu-description">Référence technique et guides</div>
                                </Link>
                                <Link to="/developer" className="submenu-item">
                                    <div className="submenu-title">Developer</div>
                                    <div className="submenu-description">Portail développeur et clés d'API</div>
                                </Link>
                                <Link to="/api-tarifs" className="submenu-item">
                                    <div className="submenu-title">Tarifs</div>
                                    <div className="submenu-description">Forfaits et options de tarification</div>
                                </Link>
                            </div>
                        )}
                    </div> */}

                    <div className="mobile-menu-item">
                        <button className="dropdown-trigger" onClick={toggleSitesDropdown}>
                            Nos sites <span className="dropdown-arrow">{sitesExpanded ? '▲' : '▼'}</span>
                        </button>

                        {sitesExpanded && (
                            <div className="mobile-submenu">
                                <Link to="/entreprises" className="submenu-item">
                                    <div className="submenu-title">Datagreffe Entreprises</div>
                                </Link>
                                <Link to="/politique" className="submenu-item">
                                    <div className="submenu-title">Datagreffe Justice</div>
                                </Link>
                            </div>
                        )}
                    </div>

                    <Link to="https://datagreffe.ci/dashboard" className="mobile-menu-item accent">
                        Accès client
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default MobileMenu;